<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @updateShipped="updateShipped"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <el-badge
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          v-if="allow('S')"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-primary"
            v-if="allow('S')"
            :disabled="!checkedRowCount"
            @click="shipped"
          >
            {{ $l('btn_shipped') || '出货完成' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>

        <SearchTabs class="ml-2" v-model="isAllShipments" @change="reload" />

        <el-checkbox
          v-model="isNotSku"
          size="small"
          class="ml-2 checkbox-nocode"
          border
          @change="reload"
        >
          {{ $l('btn_isNotSku') || '包含无SKU产品' }}
        </el-checkbox>
      </PageHeader>
      <template #toolbar_btn>
        <SortFieldsPopover
          v-model="sortFields"
          funcListName="ftyPurchaseDetailPageList"
          style="margin-right: 0.8em;"
          @change="reload"
        />
      </template>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
    <UpdateShipped
      :visible="updateShippedOptions.visible"
      :amzPurchaseDetailCode="updateShippedOptions.amzPurchaseDetailCode"
      @reload="reload"
      @close="close"
    ></UpdateShipped>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import UpdateShipped from '../update-shipped'
import EditLoading from '@/mixins/edit-loading'
import SortFieldsPopover from '@/views/ecom/components/sort-fields-popover'
import SearchTabs from './search-tabs.vue'
export default {
  mixins: [BaseTable, EditLoading],
  components: {
    PageMain,
    PageHeader,
    UpdateShipped,
    SortFieldsPopover,
    SearchTabs,
  },
  data() {
    return {
      usePage: true,
      updateShippedOptions: { visible: false, amzPurchaseDetailCode: '' },
      sortFields: [],
      checkedRows: [],
      isAllShipments: 'N',
      isNotSku: false,
    }
  },
  computed: {
    checkedRowCount() {
      let tmp = this.checkedRows || []
      tmp = tmp.filter((e) => e.amzPurchaseStatus == 'Y')
      return tmp?.length || 0
    },
  },
  methods: {
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzFtyPurchaseDetailListingApi({
          ...form,
          ...this.page,
          sortFields: this.sortFields,
          isAllShipments: this.isAllShipments,
          isNotSku: this.isNotSku ? 'Y' : 'N',
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query }) {
      this.$router.push({
        name: 'ecom-awsBiz-ftyPurchase-detail',
        params: { pageType, ...params },
        query,
      })
    },
    async shipped() {
      if (!this.checkedRowCount) {
        this.$message({
          message: this.$l('tips_select_detail') || '请选择明细',
          type: 'warning',
        })
        return
      }
      const confirm = await this.$confirm(
        this.$l('tips_update_detail_shipped') || '是否要更新为出货完成？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return false
      if (this.loadingOpen()) return
      const codes = this.checkedRows
        .filter((e) => e.amzPurchaseStatus == 'Y')
        .map((e) => e.amzPurchaseDetailCode)
      const res = await this.$api
        .ecomAmzFtyPurchaseDetailShippedApi({ codes })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_update_no') || '更新失败')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_update_ok') || '更新成功！',
        type: 'success',
      })
      this.clearCheckboxRow()
      this.reload()
    },
    close() {
      this.updateShippedOptions = { visible: false, amzPurchaseDetailCode: '' }
    },
    updateShipped({ amzPurchaseDetailCode }) {
      this.updateShippedOptions = { visible: true, amzPurchaseDetailCode }
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}

::v-deep {
  .checkbox-nocode.el-checkbox.is-bordered.el-checkbox--small {
    height: 31px;
  }
}
</style>
